import { create } from "zustand";
// ---------------------------------------------------------------------------
// Helpers
// ---------------------------------------------------------------------------
const defaultState = () => ({
    chargeFilter: "80",
    chargingOptionsResponse: null,
    forecastedSoCByAsset: {},
    futureChargingOptionsResponse: null,
    lastBaseFetchAt: null,
    lastFutureFetchAt: null,
    selectedTimeLabel: "Select time",
    showFuture: false,
    time: "",
    timePanel: "Departure",
    timeUnits: ""
});
// Internal helper to upsert an asset state
const upsert = (map, assetId, mutator) => {
    const current = map[assetId] ?? defaultState();
    return { ...map, [assetId]: mutator(current) };
};
// ---------------------------------------------------------------------------
// Store
// ---------------------------------------------------------------------------
export const useChargingPersistenceStore = create((set, get) => ({
    assetChargingByAsset: {},
    getAssetState: (assetId) => get().assetChargingByAsset[assetId] ?? defaultState(),
    opsPlanner: defaultState(),
    reset: (assetId) => set((state) => ({ assetChargingByAsset: { ...state.assetChargingByAsset, [assetId]: defaultState() } })),
    setChargeFilter: (assetId, value) => set((state) => ({
        assetChargingByAsset: upsert(state.assetChargingByAsset, assetId, (prev) => ({
            ...prev,
            chargeFilter: value
        }))
    })),
    setChargingOptionsResponse: (assetId, data) => set((state) => ({
        assetChargingByAsset: upsert(state.assetChargingByAsset, assetId, (prev) => ({
            ...prev,
            chargingOptionsResponse: data,
            lastBaseFetchAt: Date.now()
        }))
    })),
    setFutureChargingOptionsResponse: (assetId, data) => set((state) => ({
        assetChargingByAsset: upsert(state.assetChargingByAsset, assetId, (prev) => ({
            ...prev,
            futureChargingOptionsResponse: data,
            lastFutureFetchAt: Date.now(),
            showFuture: true
        }))
    })),
    setTime: (assetId, payload) => set((state) => ({
        assetChargingByAsset: upsert(state.assetChargingByAsset, assetId, (prev) => ({
            ...prev,
            selectedTimeLabel: payload.selectedTimeLabel,
            showFuture: payload.showFuture,
            time: payload.time,
            timePanel: payload.timePanel,
            timeUnits: payload.timeUnits
        }))
    }))
}));
